import React, { useContext, useState } from "react"
import { Modal } from "react-bootstrap";
import {
  Button,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  Switch,
  FormControlLabel
} from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function AddPieceModal({
  showModalAdd,
  setShowModalAdd,
  handleAddPieces,
  selectedAddPieces,
  grupoPecas,
  postPieces,
  checkSaveBtn
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  const [newGroup, setNewGroup] = useState(false);

  return (
    <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-start mb-2">
            <FormControlLabel
              className="d-flex align-items-center"
              label="NOVO GRUPO"
              control={
                <Switch
                  checked={newGroup}
                  onChange={() => setNewGroup(!newGroup)}
                />
              }
            />
          </div>

          <div className="d-flex flex-row">
            <InputLabel className="d-flex flex-column me-1 w-50">
              {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.labels.peca}
              <TextField
                className="mb-3"
                name="pecaGrupo_CodPeca"
                required
                fullWidth
                id="outlined-basic"
                placeholder="Nome do Produto"
                onChange={({ target }) => handleAddPieces(target, "PECA")}
              />
            </InputLabel>

            <InputLabel
              className="d-flex flex-column me-1 w-50"
            >
              {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.labels.grupo}
              {newGroup ? (
                < TextField
                  className="mb-3"
                  name="pecaGrupo_Nome"
                  required
                  fullWidth
                  id="outlined-basic"
                  placeholder="Nome do Produto"
                  onChange={({ target }) => handleAddPieces(target, "PECA")}
                />
              ) : (
                <Select
                  className=""
                  value={selectedAddPieces.pecaGrupo_Nome}
                  onChange={({ target }) => {
                    handleAddPieces({
                      name: "pecaGrupo_Nome",
                      value: target.value
                    }, "PECA")
                  }}
                >
                  {grupoPecas.map((itemProd, i) => (
                    <MenuItem
                      key={`grupPiece-${itemProd.prodGrupo_GrupoNome}-${i}`}
                      value={itemProd.prodGrupo_GrupoNome}
                    >
                      {itemProd.prodGrupo_GrupoNome}
                    </MenuItem>
                  ))}
                </Select>
              )}

            </InputLabel>
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalAdd(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => postPieces(selectedAddPieces)}
          disabled={checkSaveBtn(selectedAddPieces)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.pecas.modal.adicionarPeca.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal >
  )
}

